import * as React from "react";
const SvgMenudots = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#6C737F"
      d="M5.833 9.999a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Zm5.834 0a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0Zm5.833 0a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z"
    />
  </svg>
);
export default SvgMenudots;
